import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { t } from '../i18n'
import { ArrowLeft } from './Icons'

/* Back goes to the previous screen (history, so its scroll position comes
   back, spec 6). Someone who landed here from outside goes to Početna. */
export function useBack() {
  const navigate = useNavigate()
  const location = useLocation()
  return () => (location.key !== 'default' ? navigate(-1) : navigate('/'))
}

/* Sticky header of topic, source, category, search and story pages. */
export default function PageHeader({ title, avatar = null, action = null, className = '' }) {
  const back = useBack()
  return (
    <header className={`page-header ${className}`}>
      <button
        type="button"
        className="icon-button back-button"
        aria-label={t('common.back')}
        onClick={back}
      >
        <ArrowLeft size={22} />
      </button>
      {avatar}
      <h1 className="page-title">{title}</h1>
      {action && <div className="page-header-action">{action}</div>}
    </header>
  )
}
